import type { BigDecimal } from "@solomon-labs/bigdecimal";

export interface TokenBalances {
    /** Current Token-2022 USDv. */
    usdv: BigDecimal | null;
    /** Retired classic-SPL USDv, retained only for the upgrade flow. */
    legacyUsdv: BigDecimal | null;
    usdc: BigDecimal | null;
    usdt: BigDecimal | null;
    susdv: BigDecimal | null;
    solo: BigDecimal | null;
}

export type TokenBalanceKey = keyof TokenBalances;
export type TokenBalanceDelta = Partial<Record<TokenBalanceKey, BigDecimal>>;

export interface BalanceOverrideState {
    /** Expected balances after the swap */
    expectedBalances: TokenBalances;
    /** Snapshot of stored balances before the swap — used to detect when on-chain has caught up */
    preSwapBalances: TokenBalances;
    /** Mutation version that created this override */
    version: number;
}

export const INITIAL_BALANCES: TokenBalances = {
    usdv: null,
    legacyUsdv: null,
    usdc: null,
    usdt: null,
    susdv: null,
    solo: null
};
